<div class="view-content">
  @if (success()) {
    <div class="view-section success">
      <app-animated-check></app-animated-check>
      <p>{{ 'jobboard.views.unsubscribe-talentpool.success-talentpool' | transloco }}</p>
    </div>
  } @else {
    <div class="view-section">
      <div class="row">
        <div class="col-12 col-md-4 image">
          <img src="./assets/img/talentpool-email.png" />
        </div>
        <div class="col-12 col-md-8 info ps-0 ps-md-5">
          <h4 [innerHTML]="'jobboard.views.unsubscribe-talentpool.title' | transloco"></h4>
          <p class="mb-3" [innerHTML]="'jobboard.views.unsubscribe-talentpool.question' | transloco"></p>
          <form [formGroup]="form">
            <div class="form-group form-floating" [class.invalid]="form.get('email').invalid && formSubmitAttempt()">
              <input
                type="email"
                class="form-control"
                formControlName="email"
                [placeholder]="'jobboard.views.unsubscribe-talentpool.email-placeholder' | transloco"
                [autocomplete]="'off'"
                maxlength="100"
                id="email"
              />
              <label for="email">{{ 'jobboard.views.unsubscribe-talentpool.email-placeholder' | transloco }}</label>
              <div class="validation">
                @if (form.get('email').hasError('required')) {
                  <p>{{ 'ct-library.validation.required' | transloco }}</p>
                }
                @if (form.get('email').hasError('pattern') || form.get('email').hasError('email')) {
                  <p>{{ 'ct-library.validation.email' | transloco }}</p>
                }
              </div>
            </div>
          </form>
          <div class="captcha-wrapper">
            <ct-lib-friendly-captcha
              #friendlyCaptcha
              [class.invalid]="formSubmitAttempt() && captchaCode.invalid"
              [control]="captchaCode"
            >
            </ct-lib-friendly-captcha>
          </div>
          <button class="ct-btn ct-btn-themed-solid mt-3" (click)="submitUnsubscribeForm()">
            {{ 'jobboard.views.unsubscribe-talentpool.button' | transloco }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
